const faqData = [
  {
    q: '91电影视频是否需要注册或付费？',
    a: '完全不需要。91电影视频所有内容均为免费在线观看，无需注册账号，无需任何付费，打开网站即可畅享全部国产精品影视资源。',
  },
  {
    q: '视频画质如何？支持哪些清晰度？',
    a: '平台默认提供1080P全高清画质，部分热门影片支持4K超清。采用先进的视频编码技术，确保画面清晰流畅，色彩还原真实，给观众带来影院级观影体验。',
  },
  {
    q: '是否需要下载专用播放器或插件？',
    a: '无需下载任何播放器或浏览器插件。91电影视频基于HTML5技术，在主流浏览器（Chrome、Edge、Safari、Firefox）中均可直接播放，即点即看，方便快捷。',
  },
  {
    q: '内容更新频率如何？',
    a: '我们保持每日更新，每天新增50部以上国产影视内容，涵盖最新上映的国产电影、热播电视剧、网络自制剧等。片库持续扩充中，确保用户总有新片可看。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91电影视频全面适配桌面电脑、平板和手机端。无论在Windows、Mac、iOS还是Android设备上，都能获得流畅一致的观影体验，随时随地看国产好片。',
  },
  {
    q: '观看时是否有广告干扰？',
    a: '91电影视频承诺全站无广告干扰。所有影片播放过程中不会插入任何贴片广告、弹窗广告或强制跳转，让观众专注于影片本身，享受纯净观影体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于91电影视频的常见疑问，这里都有解答
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="shrink-0 w-5 h-5 flex items-center justify-center rounded bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}